import {EventHandler} from "../EventDispatcher";
import {IpcMainInvokeEvent} from "electron";
import CreateDownloadFromResourceRequest from "../../UseCase/Request/CreateDownloadFromResourceRequest";
import getCreateDownloadFromResource from "../../DependencyInjection/createDownloadFromResource";
import Resource from "../../Entity/Resource";
import getEventDispatcher from "../../DependencyInjection/eventDispatcher";
import Document from "../../Entity/Document";
import Status from "../../ValueObject/Status";
import DocumentDownload from "../../Entity/DocumentDownload";

const eventDispatcher = getEventDispatcher();

function createDocuments(content: any): Document[] {
    return content.filesInResource.map((file: any): Document => {
        return new Document(
            file.file_id,
            file.metadata.filename,
            parseInt(file.metadata.filesize),
            file.metadata.description,
            Date.parse(file.metadata.entityChanged),
            Date.now(),
            content.timelapse ?? 0,
            Date.now(),
            file.metadata.mimetype,
            file.metadata.description,
            file.metadata.mimetype,
            file.media_uuid,
            file.metadata.entityBundle,
            Status.PENDING,
            0
        );
    });
}

function createRequest(content: any): CreateDownloadFromResourceRequest {
    return new CreateDownloadFromResourceRequest(
        new Resource(
            parseInt(content.id),
            content.metadata.name,
            content.metadata.description,
            content.media_uuid,
            Date.parse(content.entityChanged),
            Date.now(),
            content.timelapse ?? 0
        ),
        createDocuments(content),
        content.sessionToken ?? ''
    );
}

const CreateResourceListener: EventHandler<any> = async (event: IpcMainInvokeEvent, content: any): Promise<void> => {
    const documentDownloads: DocumentDownload[] = getCreateDownloadFromResource().create(createRequest(content));

    for (const documentDownload of documentDownloads) {
        await eventDispatcher.dispatch('AddDownloadAction', documentDownload);
    }

    await eventDispatcher.dispatch('AddCurrentDownloadAction');
}

export default CreateResourceListener;